document.addEventListener('DOMContentLoaded', function () {
  const cartWrappers = document.querySelectorAll('.w-commerce-commercecartwrapper');

  cartWrappers.forEach((cartWrapper) => {
    const cartContainerWrapper = cartWrapper.querySelector('.w-commerce-commercecartcontainerwrapper');
    const cartOpenLink = cartWrapper.querySelector('.w-commerce-commercecartopenlink');
    const cartCloseLink = cartWrapper.querySelector('.w-commerce-commercecartcloselink');

    function openCart() {
      cartWrapper.setAttribute('data-cart-open', '');
      cartContainerWrapper.style.display = 'block';

      requestAnimationFrame(() => {
        cartContainerWrapper.style.opacity = '1';
        document.body.style.overflow = 'hidden';
        cartContainerWrapper.style.transform = 'translateX(0)';
      });
    }

    function closeCart() {
      cartContainerWrapper.style.opacity = '0';
      document.body.style.overflow = '';
      cartContainerWrapper.style.transform = 'translateX(30px)';

      setTimeout(() => {
        cartContainerWrapper.style.display = 'none';
        cartWrapper.removeAttribute('data-cart-open');
      }, 300);
    }

    function toggleCart() {
      const isOpen = cartWrapper.hasAttribute('data-cart-open');
      isOpen ? closeCart() : openCart();
    }

    cartOpenLink?.addEventListener('click', function (e) {
      e.preventDefault();
      toggleCart();
    });

    cartCloseLink?.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });
});
